<template>
  <div>
    <b-form @submit.prevent.stop="getLogs">
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <label for="from">Date From</label>
              <b-form-datepicker id="from" v-model="searchParams.dateTimeFrom" class="mb-2" size="sm"></b-form-datepicker>
            </b-col>
            <b-col>
              <label class="invisible">:</label>
              <b-form-timepicker v-model="timeFrom" :hour12="false" size="sm"></b-form-timepicker>
            </b-col>
            <b-col>
              <label for="to">Date To</label>
              <b-form-datepicker id="to" v-model="searchParams.dateTimeTo" class="mb-2" size="sm"></b-form-datepicker>
            </b-col>
            <b-col>
              <label class="invisible">:</label>
              <b-form-timepicker v-model="timeTo" :hour12="false" size="sm"></b-form-timepicker>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-button class="float-right" variant="primary" size="sm" @click="getLogs">Submit</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>

    <b-row class="mt-3">
      <b-col>
        <b-list-group>
          <b-list-group-item v-for="item in items" :key="item.id">
            <b-row>
              <b-col>
                <span v-html="formatDatetime(item.dateTime)"></span> <small class="ml-5">ID : {{ item.id }}</small>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span style="cursor: pointer; font-size: 0.9em;" class="d-block overflow-hidden"
                      :class="{'text-truncate':!item.show}"
                      @click="item.show = !item.show">{{ item.message }}</span>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import _ from 'lodash';
import adminServices from '../../services/adminServices';

export default {
  name: "ExceptionLogs",
  data() {
    return {
      searchParams: {
        dateTimeFrom: dayjs().format('YYYY-MM-DD'),
        dateTimeTo: dayjs().add(1, 'day').format('YYYY-MM-DD'),
      },
      timeFrom: dayjs().format('HH:mm:ss'),
      timeTo: '00:00:00',
      items: []
    }
  },
  methods: {
    getLogs() {
      const searchParams = _.cloneDeep(this.searchParams);
      searchParams.dateTimeFrom = dayjs(searchParams.dateTimeFrom + 'T' + this.timeFrom)
          .utc().format('YYYY-MM-DD HH:mm:ss');
      searchParams.dateTimeTo = dayjs(searchParams.dateTimeTo + 'T' + this.timeTo)
          .utc().format('YYYY-MM-DD HH:mm:ss');

      return adminServices.getApplicationExceptionLogs(searchParams)
          .then((resp) => {
            this.items = _.map(resp.data, item => {
              return {...item, ...{show: false}}
            });
          });
    },
    formatDatetime(value) {
      if (!value) return '';
      if (!dayjs(value).isValid()) return value;
      return dayjs(value + 'Z').format('[<small>]YYYY-MM-DD[</small>] HH:mm:ss');
    }
  },
}
</script>

<style scoped>

</style>